<template>
    <div>
        <b-breadcrumb :items="breadCrumbs" />

        <div class="row mb-3">
            <div class="col-12">
                <b-btn variant="primary" size="md" class="float-right" @click="openTrackingModal">
                    Add Order & Tracking
                </b-btn>
            </div>
        </div>

        <b-row class="mt-3">
            <b-col md="12">
                <b-table :items="pendingOrders" :fields="fields" v-if="pendingOrders">
                    <template slot="cell(actions)" slot-scope="row">
                        <div style="width:200px;">
                            <b-button size="sm" variant="primary" @click="openTrackingModalIndividual(row.item)">
                                Add Tracking
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row v-if="!pendingOrders || pendingOrders.length == 0">
            <b-col md="6" class="my-1 offset-md-3">
                <b-alert show variant="success">
                    No pending orders yet!
                </b-alert>
            </b-col>
        </b-row>

        <b-modal ref="trackingModal" title="Scan Order & Tracking" ok-title="Submit" @shown="onModalShown"
            @ok="submitTracking">
            <b-form-group v-if="!selectedOrder" label="Scan Order Number">
                <b-form-input ref="orderInput" v-model.trim="orderNumber" @keydown.enter.prevent="focusTracking" />
            </b-form-group>

            <b-form-group label="Scan Tracking Number">
                <b-form-input ref="trackingInput" v-model.trim="trackingNumber"
                    @keydown.enter.prevent="submitTracking" />
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "tracking-numbers",

    data() {
        return {
            pendingOrders: null,
            selectedOrder: null,
            orderNumber: "",
            trackingNumber: "",

            fields: [
                { key: "order_id", label: "Order ID", sortable: true },
                { key: "firstname", label: "First Name" },
                { key: "lastname", label: "Last Name" },
                { key: "shipping_method", label: "Shipping Method" },
                { key: "actions", label: "Actions" }
            ],

            breadCrumbs: [
                { text: "Dashboard", to: { name: "dashboard" } },
                { text: "Tracking Numbers", active: true }
            ]
        };
    },

    mounted() {
        this.getPendingOrders();
    },

    methods: {
        getPendingOrders() {
            let loader = this.$loading.show();

            this.$http.get(this.APIURL + this.BRAND + "/int-pending-orders").then(
                response => {
                    this.pendingOrders = response.data;
                    loader.hide();
                },
                error => {
                    loader.hide();
                    console.log(error);
                }
            );
        },

        openTrackingModal() {
            this.selectedOrder = null;
            this.orderNumber = "";
            this.trackingNumber = "";
            this.$refs.trackingModal.show();
        },

        openTrackingModalIndividual(order) {
            this.selectedOrder = order;
            this.orderNumber = "";
            this.trackingNumber = "";
            this.$refs.trackingModal.show();
        },

        onModalShown() {
            this.$nextTick(() => {
                if (this.selectedOrder) {
                    this.$refs.trackingInput && this.$refs.trackingInput.focus();
                } else {
                    this.$refs.orderInput && this.$refs.orderInput.focus();
                }
            });
        },

        focusTracking() {
            this.$nextTick(() => {
                this.$refs.trackingInput && this.$refs.trackingInput.focus();
            });
        },

        submitTracking(bvModalEvt) {
            if (bvModalEvt) {
                bvModalEvt.preventDefault();
            }

            const isManualMode = !this.selectedOrder;

            // INDIVIDUAL ORDER MODE
            if (this.selectedOrder) {
                if (!this.trackingNumber || this.trackingNumber.trim() === "") {
                    this.$swal("Error", "Tracking number is required", "error");
                    this.$nextTick(() => {
                        this.$refs.trackingInput && this.$refs.trackingInput.focus();
                    });
                    return;
                }
            } else {
                // MANUAL SCAN MODE
                if (!this.orderNumber || this.orderNumber.trim() === "") {
                    this.$swal("Error", "Order number is required", "error");
                    this.$nextTick(() => {
                        this.$refs.orderInput && this.$refs.orderInput.focus();
                    });
                    return;
                }

                if (!this.trackingNumber || this.trackingNumber.trim() === "") {
                    this.$swal("Error", "Tracking number is required", "error");
                    this.$nextTick(() => {
                        this.$refs.trackingInput && this.$refs.trackingInput.focus();
                    });
                    return;
                }
            }

            const orderId = this.selectedOrder
                ? this.selectedOrder.order_id
                : this.orderNumber;

            const payload = {
                order_id: orderId,
                tracking_number: this.trackingNumber
            };

            let loader = this.$loading.show();

            this.$http.post(this.APIURL + this.BRAND + "/submit-pending-orders", payload)
                .then(response => {
                    loader.hide();

                    if (response.data.status === "success") {
                        this.getPendingOrders();

                        if (isManualMode) {
                            this.$refs.trackingModal.hide();

                            this.$swal({
                                title: "Success",
                                text: response.data.message,
                                type: "success",
                                timer: 1500,
                                showConfirmButton: false
                            }).then(() => {
                                this.selectedOrder = null;
                                this.orderNumber = "";
                                this.trackingNumber = "";
                                this.$refs.trackingModal.show();
                            });
                        } else {
                            this.$swal("Success", response.data.message, "success");
                            this.$refs.trackingModal.hide();
                        }
                    } else {
                        this.$swal("Error", response.data.message, "error");
                    }
                })
                .catch(error => {
                    loader.hide();
                    console.log(error);
                });
        }
    }
};
</script>